import axios, { AxiosError } from "axios"
import * as H from "history";
import { toast } from "react-toastify";
import config from "../../config";
import { dataTransformer } from "./AxiosInterceptor";


export const axiosCoreInstance = axios.create({
    baseURL: config.coreApiUrl,
    withCredentials: false,
	transformRequest: [dataTransformer].concat(axios.defaults.transformRequest!),
})


export const CoreInterceptors = {
    setupCoreTokenInterceptor: () => {
        axiosCoreInstance.interceptors.request.use((config) => {
            const token = localStorage.getItem("coreToken");
            config.headers!['Authorization'] = `Bearer ${token}`;
            return config;
        })
    },
    setupUnauthorizedCoreInterceptor: (history: H.History) => {
        axiosCoreInstance.interceptors.response.use(response => response, (error) => {
            const response = (error as AxiosError).response;
            if (response) {
                const { data, status } = response!; //We are adding the ! because we know we will have a error response here
                switch (status) {
                    case 400:
                        if (data.ModelState) {
                            const modelStateErrors: string[] = [];
                            for (const key in data.ModelState) {
                                if (data.ModelState[key]) {
                                    modelStateErrors.push(data.ModelState[key]);
                                }
                            }
                            throw modelStateErrors.flat();
                        }
                        if (data.errors) {
                            const validationErrors: string[] = Object.values(data.errors).flat() as string[];
                            toast.error(validationErrors.join(' '));
                            break;
                        }
                        toast.error(data.Message ?? data.title ?? 'Validation error');
                        break;
                    case 401:
                        if (!window.location.href.includes("login"))
                        {
                                history.push('/login');
                                break;
                        }
                        break;
                    case 403:
                        break;
                    case 404:
                        if (data){
                            toast.error(data);
                        }else{
                            toast.error('Not found');
                        }
                        break;
                    case 422:
                        if (data){
                            toast.error(data);
                        }
                        break;
                    case 500:
                        toast.error('Server error - Please Contact BEE123');
                        break;
                }
            }
            return Promise.reject(error);
        });
    },
}